export default __webpack_public_path__ + "static/media/tricko_konfety.de89eb24.jpg";